import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { carouselSettingShape } from '@bibliocommons/bc-prop-types';

import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import ListCarousel from 'app/components/shared/ListCarousel';

const WrappedListCarousel = props => {
  const dispatch = useDispatch();

  const trackClick = (list, carouselTitle, { isImage = false }) => {
    dispatch(
      trackContentClick({
        list: {
          list_id: Number(list.listId),
          list_purpose: list.purpose,
          list_title: list.title
        },
        ui: {
          ui_component_label: isImage ? undefined : list.title,
          ui_component_type: isImage ? 'link-image' : 'link-text',
          ui_container_title: carouselTitle,
          ui_container_type: 'item'
        }
      })
    );
  };

  return (
    <ListCarousel
      {...props}
      onListImageClick={(list, carouselTitle) => trackClick(list, carouselTitle, { isImage: true })}
      onListTitleClick={(list, carouselTitle) => trackClick(list, carouselTitle, { isImage: false })}
    />
  );
};

WrappedListCarousel.propTypes = {
  cardProps: PropTypes.shape({
    cardHeadingTag: PropTypes.string,
    border: PropTypes.bool,
    imageIsDecorative: PropTypes.bool,
    imageAlt: PropTypes.string,
    rectangle: PropTypes.bool
  }),
  carouselSettings: carouselSettingShape,
  carouselTitle: PropTypes.string,
  carouselTitleLink: PropTypes.string,
  containerName: PropTypes.string,
  headingTag: PropTypes.string,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      creator: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
      description: PropTypes.string,
      imageSrc: PropTypes.string,
      listId: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string
    })
  )
};

export default WrappedListCarousel;
